var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { TemplateConfiguration } from "./TemplateConfiguration";
export class CountryConfiguration {
  constructor(_data) {
    /**
     */
    __publicField(this, "Configuration");
    /**
     */
    __publicField(this, "CountryCode");
    /**
     */
    __publicField(this, "IsDeleted");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof CountryConfiguration
     */
    __publicField(this, "$type", "V1.GenerationConfiguration.CountryConfiguration");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      if (_data["Configuration"]) {
        const configuration_ = new TemplateConfiguration();
        this.Configuration = configuration_.init(_data["Configuration"]);
      }
      this.CountryCode = _data["CountryCode"];
      this.IsDeleted = _data["IsDeleted"];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["Configuration"] = this.Configuration ? this.Configuration.toJSON() : void 0;
    _data["CountryCode"] = this.CountryCode;
    _data["IsDeleted"] = this.IsDeleted;
    return _data;
  }
}
